import $        from 'jquery';
import React    from 'react';
import ReactDOM from 'react-dom';
import cx       from 'classnames';
import Video    from './video';
import Playlist from './playlist';
import Utils    from 'medscape/utils';
import Settings from './configs/settings';

/*
    Video Module
    Renders the module's title and video from the JSON config object
*/

export default class VideoModule extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      'video': this.props.video,
      'amp': null,
      'isReady': false
    }
    window.VideoModule = this;
  }
  componentWillMount() {
    if(this.props.playlist!=null) {
      this.initPlaylist();
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.isReady !== nextState.isReady) {
      return true;
    }
    if(this.state.video['config-id'] != nextState.video['config-id']){
      return true;
    }
    if(this.state.amp) {
      return false;
    } else {
      return true;
    }
  }
  initPlaylist() {
    const host = window.medscape.config.staticServer.host.length==0 ? "//img.proddev.medscapestatic.com" : window.medscape.config.staticServer.host;
    this.props.playlist.videos.forEach( (video,index)=>{
      let defaultVideo = null;
      if(video.title.length==0 || video.poster.length==0){
          defaultVideo = this.props.videos.find( (_video)=>{
              return _video["config-id"] == video["video-config-id"];
          });
          video.title = video.title.length>0 ? video.title : defaultVideo.title;
          video.poster = video.poster.length>0 ? video.poster : defaultVideo.poster;
      }
      video.watched = false;
      video.playing = this.props.video['config-id'] == video['video-config-id'];
    });
  }
  changeVideo(videoId) {
    let video = this.props.videos.find( (video)=>{
      return video["config-id"]==videoId;
    });
    if(video) {
      this.setState({
        "video":video
      });
    }
  }
  setReady() {
    this.setState({
      isReady: true
    });
  }
  setAmp(amp) {
    this.setState({
      "amp": amp
    });
  }
  render() {
    const VideoProps = {
        id: `video_player_screen-${this.props.index}`,
        config: this.state.video,
        setAmp: this.setAmp.bind(this)
    }
    let moduleClass = cx({
        'isMobile': Utils.isMobile(),
        'video-player-module': true
    })
    if(this.props.playlist!=null) {
        return (
            <div className={moduleClass}>
                <Video
                  {...VideoProps}
                  route={this.props.route}
                  setReady={this.setReady.bind(this)}
                />
                <Playlist
                  video={this.state.video}
                  amp={this.state.amp}
                  videos={this.props.playlist.videos}
                  carousel={this.props.playlist.carousel}
                  onChangeVideo={this.changeVideo.bind(this)}
                  ready={this.state.isReady}
                />
            </div>
        )
    } else {
      return (
          <div className={moduleClass}>
              <Video {...VideoProps} route={this.props.route} />
          </div>
      )
    }
  }
}

VideoModule.propTypes={
    "index": React.PropTypes.number,
    "config-id": React.PropTypes.string,
    "video": React.PropTypes.object.isRequired,
    "playlist": React.PropTypes.object,
    "videos": React.PropTypes.array
}
VideoModule.defaultProps={
    "index": 0,
    "config-id": "___",
    "video": null,
    "playlist": null,
    "videos": []
}



// WEBPACK FOOTER //
// ./medscape_modules/video/app.jsx